import { useCallback, useState } from "react";
import { useStores } from "../../components/contexts/store-provider.context";
import { Pacote } from "../../types";
import { PacoteService } from "./pacotes.service";

export function usePacotes() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Pacote[]>([]);
  const [selectedData, setSelectedData] = useState<Pacote>();
  const { produtoStore } = useStores();

  const getPacote = useCallback(async (id: string) => {
    setLoading(true);
    produtoStore.setCrudLoading("edit", true);
    const res = await PacoteService.getPacote(id);
    if (res) {
      produtoStore.setSelectedData(res);
      setSelectedData(res);
    }
    produtoStore.setCrudLoading("edit", false);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPacotes = useCallback(async () => {
    setLoading(true);
    if (!produtoStore.data) {
      produtoStore.setLoading(true);
    }

    const res = await PacoteService.getPacotes();

    if (res) {
      produtoStore.set(res);
      setData(res);
    }
    produtoStore.setLoading(false);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deletePacote = useCallback(async (data: Pacote) => {
    await PacoteService.deletePacote(data);
    produtoStore.removeItem((item) => item.id === data.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addPacote = useCallback(async (data: Pacote) => {
    await PacoteService.addPacote(data);
    produtoStore.add(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updatePacote = useCallback(async (data: Pacote) => {
    await PacoteService.updatePacote(data);
    produtoStore.update(data.id || "-1", data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteImages = useCallback(async (data: string[]) => {
    await PacoteService.deleteImages(data);
  }, []);

  return {
    getPacote,
    getPacotes,
    deletePacote,
    addPacote,
    updatePacote,
    deleteImages,
    selectedData,
    loading,
    data,
  };
}
